var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11C19.21 11 21 12.79 21 15V21H3V17C3 14.79 4.79 13 7 13H10.54C11.23 11.8 12.52 11 14 11H17ZM17 13H14C12.9 13 12 13.9 12 15V19H19V15C19 13.9 18.1 13 17 13ZM10 15H7C5.9 15 5 15.9 5 17V19H10V15ZM8 6C9.654 6 11 7.346 11 9C11 10.654 9.654 12 8 12C6.346 12 5 10.654 5 9C5 7.346 6.346 6 8 6ZM8 7.875C7.38 7.875 6.875 8.379 6.875 9C6.875 9.621 7.38 10.125 8 10.125C8.62 10.125 9.125 9.621 9.125 9C9.125 8.379 8.62 7.875 8 7.875ZM15.5 3C17.43 3 19 4.57 19 6.5C19 8.43 17.43 10 15.5 10C13.57 10 12 8.43 12 6.5C12 4.57 13.57 3 15.5 3ZM15.5 5C14.673 5 14 5.673 14 6.5C14 7.327 14.673 8 15.5 8C16.327 8 17 7.327 17 6.5C17 5.673 16.327 5 15.5 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMg);
export default __webpack_public_path__ + "static/media/userMg.d5ee2be0fb471d12d0e69e530d3ace50.svg";
export { ForwardRef as ReactComponent };